// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import PlayCircle from "@awc/XDL/Icons/PlayCircle";
import { xScreen } from "@awc/XDL/Utilities";
import { searchHistoryStyles } from "@insite/content-library/Widgets/Header/SearchHistory";
import { css } from "styled-components";

searchHistoryStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 615px;
        padding: 0 20px 15px 20px;

        ${xScreen("lte", "md")} {
            width: 394px;
        }
    `,
};

searchHistoryStyles.icon = {
    src: PlayCircle,
    size: 8,
    color: "common.ui14",
    css: css`
        margin-right: 10px;
    `,
};
